<template>
  <div class="header">
    <div class="logo" :class="{'is-active':isActive}">
      <!--左上Logo-->
      <img
        style="width:110px;height:30px;"
        :src="$storage.getUser().systemLogo ? imgApi+$storage.getUser().systemLogo :'../../../static/img/login/logoLf.png'"
      />
    </div>
    <div class="navbar">
      <div class="btn" :class="{'is-active':isActive}" @click="handleMenu">
        <span :class="menuBtn"></span>
      </div>
      <div class="showmsg">
        <span>{{$storage.getUser().systemName?$storage.getUser().systemName:'智能收运系统'}}</span>
      </div>
      <div class="welUser">
        <span class="iconfont iconrenyuan"></span>
        <span
          class="userInfo"
          @click="userSet($storage.getUser().userId)"
        >{{$storage.getUser().alasName}}</span>,欢迎您！
      </div>
      <div class="updatePwd" @click="editPassWord">
        <span class="iconfont iconxiugaimima"></span>
        <span>修改密码</span>
      </div>
      <div class="logout" @click="logout">
        <span class="el-icon-switch-button"></span>
        <span>退出</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      menuBtn: "el-icon-s-fold",
      imgApi: api.imageLoadUrl,
    };
  },
  computed: {
    // 如果左侧菜单打开，则旋转btn180度
    isActive() {
      return !this.$store.getters.sidebar.opened;
    },
  },
  methods: {
    userSet(id) {
      //修改用户信息
      dialogVisibleShow(id);
    },
    handleMenu() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      //退出登录
      var that = this;
      this.$confirm("是否退出账户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var token = that.$util.clone_str(that.$storage.getToken());
        // console.log(that.$WBT.initWs.isReconnect);
        let p1 = new Promise((resolve, reject) => {
          (that.$WBT.initWs.isReconnect = false), resolve(true);
        });
        let p2 = new Promise((resolve, reject) => {
          that.$WBT.socket.close(), resolve(true);
        });
        let p3 = new Promise((resolve, reject) => {
          that.$store.dispatch("bindLogout", token), resolve(true);
        });
        // debugger
        Promise.all([p1, p2, p3]).then((results) => {
          // debugger
          setTimeout(function () {
            location.reload();
          }, 500);
        });
      });
    },
    editPassWord() {
      //修改密码
      dialogVisiblePswShow();
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 50px;
  display: flex;
  background: #fff;
  border-bottom: 1px solid #ccc;
  .logo {
    width: 199px;
    height: 50px;
    background: #00284d;
    color: #fff;
    text-indent: 15px;
    font-size: 18px;
    line-height: 50px;
    font-weight: 600;

    transition: 0.4s ease;
    &.is-active {
      width: 63px;
      overflow: hidden;
    }
    img {
      margin-top: 10px;
      margin-right: 20px;
    }
  }
  .navbar {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    color: #252b3a;
    position: relative;
    .btn {
      height: 50px;
      line-height: 50px;
      cursor: pointer;
      transition: 0.4s ease;
      &.is-active {
        transform: rotateY(180deg);
      }
      span {
        font-size: 28px;
        line-height: 50px;
        transition: 0.5s;
        color: #00284d;
        font-weight: 400;
      }
    }
    /*顶部左侧字体显示 */
    .showmsg {
      color: #252b3a;
      float: left;
      text-align: left;
      font-size: 18px;
      font-weight: 300;
      font-family: PingFang SC;
      padding-left: 5px;
      position: absolute;
      left: 40px;
      top: 11px;
    }

    /*用户信息显示 */
    .welUser {
      width: 250px;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 300;
      color: rgba(37, 43, 58, 1);
      text-align: right;
      position: absolute;
      right: 166px;
      top: 13px;
      .userInfo {
        text-decoration: underline;
        color: #09f;
        cursor: pointer;
      }
    }
    /* 修改密码 */
    .updatePwd {
      width: 80px;
      position: absolute;
      right: 82px;
      text-align: right;
      top: 13px;
      span {
        cursor: pointer;
      }
    }
  }

  /*退出 */
  .logout {
    width: 80px;
    height: 50px;
    background: rgba(243, 248, 255, 1);
    position: absolute;
    right: 0;

    bottom: 1px;

    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 300;
    color: rgba(37, 43, 58, 1);
    line-height: 53px;

    cursor: pointer;
  }
}

@media all and (max-width: 768px) {
  .header .logo.is-active {
    width: 0;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue